import { Text } from '@chakra-ui/react'

import type { FormBlock, FormValues } from '@/components/UI/Form/types'
import RichText from '@/components/UI/RichTextEditor/RichText'

import {
  ALGEBRA2_FINALS_PREP_PROGRAM_STRUCTURE_CONSENT_TEXT,
  type LearningLabsConsentDetails,
  PROGRAM_STRUCTURE_CONSENT_INPUT_NAME,
} from './constants'

export function getAlgebra2FinalsPrepProgramStructureConsentResponses(
  formValues: FormValues
): LearningLabsConsentDetails {
  return {
    acknowledgements: [PROGRAM_STRUCTURE_CONSENT_INPUT_NAME].filter(value => value in formValues),
  }
}

export function getAlgebra2FinalsPrepProgramStructureConsentFormInputs(): FormBlock[] {
  const programStructureConsent: FormBlock[] = [
    {
      type: 'content',
      name: 'program_structure_consent',
      content: (
        <>
          <Text variant="eyebrow" color="fg.muted" align="left" mb="16px">
            What to Expect
          </Text>
          <RichText content={ALGEBRA2_FINALS_PREP_PROGRAM_STRUCTURE_CONSENT_TEXT} />
        </>
      ),
      display: 'display',
      size: 6,
    },
    {
      type: 'multi-checkbox',
      name: PROGRAM_STRUCTURE_CONSENT_INPUT_NAME,
      label: 'Program Structure Acknowledgement',
      options: [
        {
          label: 'I agree to the program structure',
          value: `${PROGRAM_STRUCTURE_CONSENT_INPUT_NAME}-yes`,
        },
      ],
      required: true,
      size: 6,
    },
  ]

  return programStructureConsent
}
